import DataLayerManager from "../trackers/dataLayer/dataLayerManager";
import FeaturedMenuFilter from "./featuredMenuFilter";

export const filterAvailableOptions = ['thematic', 'featureddates', 'allowpets', 'mealplan', 'accommodationcategory', 'accommodationtype', 'rating', 'price', 'freecancellation', 'location', 'whentravel', 'featuredmenu'];

export default class AvailabilityFilter {
    constructor() {
        this.dataLayerManager = new DataLayerManager();
        this.extraGroupList = [];
        this.groupList = [];
        this.tagsDisplayedLimit = 8;
        this.filtersApplied = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': [],
            'featuredmenu': []
        };
        this.filterAvailableOptions = filterAvailableOptions;
        this.counterFilterAvailableGroups = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': []
        };
        this.tagList = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': []
        };
        this.filtersWithORCondition = ['accommodationcategory', 'accommodationtype', 'mealplan', 'featureddates', 'rating', 'price', 'location', 'whentravel'];
        this.filtersContainer = $('[data-container="filters"]');
        this.initialize();
        new FeaturedMenuFilter(this);
        this.searcherType = document.querySelector('.searcher-fixed')?.dataset.type ?? null;
    }

    initialize() {
        this.calculateCollapseHeight();
        this.initializeFilters();
        this.setUserFilters();
        if (this.checkAnyFiltersApplied()) {
            this.doFilter();
        }
        this.eventDelegation();
        this.initializeWithGetParams();
    };

    eventDelegation() {
        this.filtersContainer.on("click", "[data-action='filter']", (event) => {
            let currentElement = $(event.currentTarget);

            if (currentElement.hasClass('label-disabled')) {
                return false;
            }

            if (currentElement.data('field') === 'groups-counter') {
                currentElement = currentElement.prev().find("[data-filter-type]");
                currentElement.prop('checked', !currentElement.is(':checked'));
            }

            this.refreshGetParams(currentElement);

            this.sendFilterToDatalayer(currentElement);
            this.doFilter();
        });

        const body = $('body');
        body.on("click", "[data-action='reset-filters'], [data-action='restore-filters']", () => {
            this.restoreFilters();
        });

        $('[data-open="filters"]').on('click', (e) => {
            e.stopPropagation();
            this._triggerOpenCloseFilters('open');
            this.filtersContainer.addClass('show');
            body.addClass('filters-opened');
        });

        $('[data-close="filters"]').on('click', () => {
            this._triggerOpenCloseFilters('close');
            this.filtersContainer.removeClass('show');
            body.removeClass('filters-opened');
        });
    };

    _triggerOpenCloseFilters(action) {
        this.dataLayerManager.pushData(JSON.stringify({
            event: "filter_interaction",
            event_category: "status",
            event_detail_1: action,
            event_detail_2: this.searcherType,
        }));
    }

    sendFilterToDatalayer(elementContainer) {
        let data = {
            event: "filter_interaction",
            event_category: "filter",
            event_detail_1: elementContainer.data('filter-type'),
            event_detail_2: elementContainer.data('filter-name'),
            event_detail_3: elementContainer.is(':checked') ? 'check' : 'uncheck'
        };

        this.dataLayerManager.pushData(JSON.stringify(data));
    }

    doFilter() {
        this.initializeProcess();
        this.setUserFilters();
        this.applyFilters();
        this.finishProcess();
    };

    initializeProcess() {
        $('#filter_overlay').fadeIn(100);
    };

    finishProcess() {
        $('#filter_overlay').fadeOut(1000);
    };

    applyFilters() {
        this.setVisibilityAvailableGroups();
        if (!this.checkAnyFiltersApplied()) {
            myApp.book.availabilityManager.setVisibleGroups();
        }
        this.printUpdatedCounters();
        this.printGroups();
        this.updateFiltersCounterText();
        this.manageCollapseFilters();

        this.manageComingSoonMessageVisibility();

        myApp.book.availabilityManager.reorderBanners();

        this._scrollToElement();

        $('#filter_overlay').fadeOut(100);
    };

    initializeFilters() {
        myApp.book.availabilityManager.setVisibleGroups();
        this.filtersApplied = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': [],
            'featuredmenu': this.filtersApplied['featuredmenu']
        };
        this.counterFilterAvailableGroups = {
            'thematic': [],
            'featureddates': [],
            'allowpets': [],
            'mealplan': [],
            'accommodationcategory': [],
            'accommodationtype': [],
            'rating': [],
            'price': [],
            'freecancellation': [],
            'location': [],
            'whentravel': []
        };
    };

    manageCollapseFilters() {
        this.calculateCollapseHeight();
        const collapseToggles = document.querySelectorAll('.filter_content [data-action="toggle-collapse"]');

        collapseToggles.forEach(toggle => {
            const targetSelector = toggle.getAttribute("data-target");
            const targetElement = document.querySelector(targetSelector);
            const minHeight = parseInt(targetElement.style.minHeight)
            if (minHeight >= 200) {
                toggle.style.display = "flex";
            } else if (minHeight < 200) {
                toggle.style.display = "none";
            }
        });
    };

    setTagCounterAmount(group, orFiltered, categoryType) {
        let filtered = false;
        let counterFilter = true;
        if (orFiltered) {
            $.each(this.filtersApplied, (appliedCategory, ids) => {
                if (ids.length === 0 || appliedCategory === categoryType) {
                    return true;
                }
                $.each(group.categories[appliedCategory], (category, id) => {
                    if (ids.indexOf(id) >= 0) {
                        filtered = true;
                    }
                });
                if (!filtered) {
                    counterFilter = false;
                    return false;
                } else {
                    filtered = false;
                }
            });
        }

        if (counterFilter) {
            $.each(group.categories, (category, ids) => {
                if (orFiltered === false || (categoryType === category && this.filtersWithORCondition.indexOf(category) >= 0)) {
                    $.each(ids, (i, id) => {
                        if (typeof this.tagList[category] !== 'undefined' && typeof this.tagList[category][id] !== 'undefined') {
                            this.tagList[category][id]['amount']++;
                        }
                    });
                }
            });
        }
    };

    printUpdatedCounters() {
        Object.entries(this.tagList).forEach(([name, category]) => {
            let tagsDisplayed = Object.entries(category).reduce((count, [idTag, data]) => {
                const filterCounterItem = this.filtersContainer
                    .find(`[data-filter-type='${name}'][data-id='${idTag}']`)
                    .parent()
                    .next("[data-field='groups-counter']");
                const counterAmount = data.amount;
                filterCounterItem.text(counterAmount);
                return counterAmount > 0 ? count + 1 : count;
            }, 0);

            $(`[data-container-filter-type='${name}']`).toggle(tagsDisplayed > 0);
        });

        this.filtersContainer.find("[data-filter-type]").each((_, checkboxElement) => {
            const checkbox = $(checkboxElement);
            const category = checkbox.data('filter-type');
            const filterCounterItem = checkbox.parent().next("[data-field='groups-counter']");
            const isChecked = checkbox.is(":checked");

            filterCounterItem.toggleClass("label-primary label-disabled", isChecked)
                .toggleClass("label-secondary-gray", !isChecked);

            checkbox.removeClass("colored-grey").addClass("checked-primary").prop('disabled', false);

            const hideCheckbox = checkbox.closest('[data-hide="checkbox"]');
            hideCheckbox.toggle(!(parseInt(filterCounterItem.text()) === 0 && !isChecked));

            const filterTypeContainer = $(`[data-container-filter-type='${category}']`);
            const separator = filterTypeContainer.find('[data-element="separator"]');
            separator.toggle(separator.next().is(":hidden"));
        });
    };

    setUserFilters() {
        $("[data-filter-type]").each((_, checkboxElement) => {
            const checkbox = $(checkboxElement);
            const filterType = checkbox.data('filter-type');
            const filterId = checkbox.data('id');

            this.tagList[filterType] ??= {};
            this.tagList[filterType][filterId] = {amount: 0};

            if (checkbox.is(':checked') && !this.filtersApplied[filterType].includes(filterId)) {
                this.filtersApplied[filterType].push(filterId);
            } else if (!checkbox.is(':checked') && this.filtersApplied[filterType].includes(filterId)) {
                this.filtersApplied[filterType] = this.filtersApplied[filterType].filter(id => id !== filterId);
            }
        });
    };

    manageComingSoonMessageVisibility() {
        const comingSoonModule = $("[data-entity='comingSoonModule']");

        let isVisibleOnSaleSection = false;
        const isVisibleFeaturedSection = $("[data-category='featured']").is(':visible');
        const isVisibleUserExclusiveSection = $("[data-category='user_exclusive']").is(':visible');
        const isVisibleComingSoonSection = $("[data-category='coming_soon']").is(':visible');

        $.each($("[data-category='on_sale']"), (i, category) => {
            if ($(category).is(":visible")) {
                isVisibleOnSaleSection = true;
            }
        });

        if ((isVisibleOnSaleSection || isVisibleFeaturedSection || isVisibleUserExclusiveSection) && isVisibleComingSoonSection) {
            comingSoonModule.show();
        } else {
            comingSoonModule.hide();
        }
    };

    updateFiltersCounterText() {
        const countGroupsValidated = myApp.book.availabilityManager.findAllVisibleGroupsByField('visible', true).length;
        const countGroupsNoValidated = myApp.book.availabilityManager.findAllVisibleGroupsByField('visible', false).length;
        const countTotalGroups = countGroupsValidated + countGroupsNoValidated;

        const filterTitleContainer = $('[data-container="filter-title"]');
        const filterButtonContainer = $('[data-container="filter-button"]');
        const resetFilters = document.querySelector("[data-container='reset-filters-lg']");
        const resetFiltersMobile = document.querySelector(".btn-restore");
        const filterCount = document.querySelector("[data-name='filter-count']");
        const defaultFilterTitle = $('[data-container="default-filter-title"]');
        const hideOnSortElements = $("[data-hide-on-sort]");

        const updateFilterButton = (template, count) => {
            if (template) {
                filterButtonContainer.html(template.replace("%currentCount%", count));
            }
        };

        const updateFilterTitle = (template, validatedCount, totalCount) => {
            if (template) {
                filterTitleContainer.html(template.replace("%currentCount%", validatedCount).replace("%totalCount%", totalCount));
                defaultFilterTitle.hide();
            }
        };

        if (this.checkAnyFiltersApplied()) {
            const filterTitleTextResult = filterTitleContainer.data("template-text");
            const filterButtonApply = filterButtonContainer.data("template-text");
            const filterButtonApplyOneResult = filterButtonContainer.data("template-text-one-result");

            updateFilterButton(countGroupsValidated > 1 ? filterButtonApply : filterButtonApplyOneResult, countGroupsValidated);
            updateFilterTitle(filterTitleTextResult, countGroupsValidated, countTotalGroups);
            filterTitleContainer.show();
        } else {
            defaultFilterTitle.show();
            filterTitleContainer.hide();
        }

        if (this.checkRestoreFiltersButtonVisibility()) {
            resetFilters.style.display = '';
            filterCount.style.display = '';
            resetFiltersMobile.classList.add('active');
            $('[data-action="restore-filters"]').show();
            hideOnSortElements.hide();
        } else {
            resetFilters.style.display = 'none';
            filterCount.style.display = 'none';
            resetFiltersMobile.classList.remove('active');
            updateFilterButton(filterButtonContainer.data("template-text"), countTotalGroups);
            hideOnSortElements.show();
        }
    };

    setVisibilityAvailableGroups() {
        myApp.book.availabilityManager.findAllVisibleGroups().forEach(group => {
            const allowPetsFilterInvalid = !this.validateAllowPetsFilter(group.id) && this.filtersApplied.allowpets.length !== 0;

            const hasCategories = !allowPetsFilterInvalid && !this.filterAvailableOptions.some(category => {
                const categoryInvalid = !this.validateCategoriesTypeFilter(group.id, category) && this.filtersApplied[category].length !== 0 && category !== 'allowpets';
                if (categoryInvalid && this.filtersWithORCondition.includes(category)) {
                    this.setTagCounterAmount(group, true, category);
                }
                return categoryInvalid;
            });

            group.visible = hasCategories;
            if (hasCategories) {
                this.setTagCounterAmount(group, false, '');
            }
        });
    };

    validateCategoriesTypeFilter(groupId, categoryType) {
        const categoriesFiltersSelected = this.filtersApplied[categoryType];
        const group = myApp.book.availabilityManager.findGroupByField('id', groupId);

        if (this.filtersWithORCondition.includes(categoryType)) {
            return categoriesFiltersSelected.some(filterId => group.categories[categoryType].includes(filterId));
        }

        return categoriesFiltersSelected.every(filterId => group.categories[categoryType].includes(filterId));
    };

    validateAllowPetsFilter(groupId) {
        const group = myApp.book.availabilityManager.findGroupByField('id', groupId);
        if (this.filtersApplied.allowpets.length > 0) {
            return group.pets;
        }
    };

    checkAnyFiltersApplied() {
        return Object.values(this.filtersApplied).some(filter => filter.length > 0);
    };

    // Don´t need to check featured menu because is not really a filter.
    checkRestoreFiltersButtonVisibility() {
        return Object.entries(this.filtersApplied).filter(([key]) => key !== 'featuredmenu').some(([, arr]) => arr.length > 0);
    };

    printGroups() {
        let exclusiveGroupsContainer;

        $.each(myApp.book.availabilityManager.findAllVisibleGroups(), (i, group) => {
            let groupElementQuery = "[data-entity='group'][data-id='" + group.id + "']";
            if (myApp.book.additionalMealPlansByChollo) {
                groupElementQuery += "[data-chollo-id='" + group.cholloId + "']";
            }

            const groupElement = $(groupElementQuery);

            const groupElementCategory = groupElement.closest(".group-list");
            const currentContainer = $("[data-container-list='groups']").find(groupElementCategory);
            groupElement.hide();

            if (group.visible) {
                if (myApp.book.additionalMealPlansByChollo) {
                    this._filterByMealplan(groupElement, group);
                }
                groupElement.show();
                currentContainer.append(groupElement);
                if (!exclusiveGroupsContainer && currentContainer.attr('data-category') === 'user_exclusive') {
                    exclusiveGroupsContainer = currentContainer;
                }
            }

            if (!this.checkAnyFiltersApplied()) {
                if ($(currentContainer).attr('data-category') === 'on_sale') {
                    myApp.book.availabilitySorter.appendBannerBetweenElements(i, currentContainer);
                }
            }
        });

        if (exclusiveGroupsContainer) {
            const exclusiveTextClosure = exclusiveGroupsContainer.find('[data-target="exclusive-closure"]');
            exclusiveGroupsContainer.append(exclusiveTextClosure);
        }

        $.each($("[data-container-list='groups'] [data-category]"), (i, groupList) => {
            $(groupList).show();
            if (!$(groupList).find("[data-entity='group']").is(":visible")) {
                $(groupList).hide();
            }
        });

        const extraGroupsMessage = $('[data-not-sortable]');

        const numOfGroups = $("[data-container-list='groups'] [data-is-extra='0']:visible").length;
        const numOfExtraGroups = $("[data-container-list='groups'] [data-is-extra='1']:visible").length;
        const extraGroupsMessageText = document.querySelector("[data-entity='no-extra-chollo-title']");
        const extraGroupsMessageDescription = document.querySelector("[data-entity='no-extra-chollo-description']");

        if (extraGroupsMessage && extraGroupsMessageText && extraGroupsMessageDescription) {
            if (numOfExtraGroups > 0) {
                extraGroupsMessage.show();
                if (numOfGroups > 0) {
                    extraGroupsMessageText.innerHTML = myApp.translator['search.page.recommendations.title'];
                    extraGroupsMessageDescription.innerHTML = myApp.translator['search.page.recommendations.description'];
                } else {
                    extraGroupsMessageText.innerHTML = myApp.translator['search.page.recommendations.no.filter.title'];
                    extraGroupsMessageDescription.innerHTML = myApp.translator['search.page.recommendations.no.filter.description'];
                }
            } else {
                extraGroupsMessage.hide();
            }
        }
    };

    restoreFilters() {
        this.restoreFilterCheckboxes();
        this.initializeFilters();
        this.doFilter();
        this._scrollToElement();
        this.restoreFilterParams();
    };

    restoreFilterCheckboxes() {
        $("[data-action='filter']").prop('checked', false);
        this.filtersContainer.find("[data-filter-type]").closest('.checkbox').removeClass('active');
        if (this.filtersApplied['featuredmenu'].length <= 0) {
            $('[data-container="filter-title"]').hide();
        }
    }

    restoreFilterParams() {
        let getParams = new URLSearchParams(window.location.search);
        const allParams = getParams.keys();
        for (const key of Array.from(allParams)) {
            if (Object.keys(this.tagList).includes(key)) {
                getParams.delete(key);
            }
        }

        window.history.replaceState({}, '', getParams ? ('?' + getParams.toString()) : window.location.pathname);
    }

    counterFiltersOnFilterCategory(category) {
        if (typeof this.tagList[category] === 'undefined') return;
        return (this.tagList[category].filter(categoryCheckbox => categoryCheckbox['amount'] > 0).length > 8);
    }

    calculateCollapseHeight() {
        const filtersCollapse = $('[name="filter-collapse"]');

        filtersCollapse.each((i, filterCollapse) => {
            let collapseHeight = 0;
            $(filterCollapse).children().each((item, filter) => {
                if (item < this.tagsDisplayedLimit && $(filter).css('display') != 'none') {
                    collapseHeight += $(filter).outerHeight(true);
                }
            });
            $(filterCollapse).css('min-height', Math.round(collapseHeight) + 'px');
        });
    }

    initializeWithGetParams() {
        let validFilter = false;
        $.each(this.filterAvailableOptions, (i, type) => {
            let filterParam = new URLSearchParams(window.location.search)
            for (const [key, value] of filterParam.entries()) {
                if (key == type) {
                    const filterCheckbox = $('[data-filter-type="' + key + '"][data-id="' + value + '"]');
                    if (filterCheckbox.length > 0) {
                        validFilter = true;
                        filterCheckbox.click();
                    }
                }
            }
        });

        if (!validFilter) {
            this.finishProcess();
        }
    }

    refreshGetParams(currentElement) {
        const getParams = new URLSearchParams(window.location.search);
        const filterType = currentElement.parent().find('[data-filter-type]').data('filter-type');
        const filterId = currentElement.parent().find('[data-filter-type]').data('id');

        if (currentElement.is(':checked')) {
            const existingParams = getParams.getAll(filterType);
            if (!existingParams.includes(filterId.toString())) {
                getParams.append(filterType, filterId);
            }
        } else {
            const params = getParams.getAll(filterType).filter(value => value !== filterId.toString());
            getParams.delete(filterType);
            params.forEach(value => getParams.append(filterType, value));
        }

        const newUrl = getParams.toString() ? `?${getParams.toString()}` : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    _filterByMealplan(element, group) {
        const filtersChecked = this.filtersApplied.mealplan;
        const mealPlans = myApp.book.additionalMealPlansByChollo[group.cholloId];
        const additionalMealPlansContainer = $(element).find('[data-entity="additional-meal-plans"]');
        const groupTitle = $(element).find('.group-title');
        const groupDescription = $(element).find('[data-entity="description"]');
        const groupPrice = $(element).find('.chollo-price');
        const schematicLabels = $(element).find('[data-entity="schematic-labels"]');
        const schematicLabelTemplate = $(schematicLabels.children()[0]).clone(true);

        if (filtersChecked.length > 0) {
            for (let filter of filtersChecked) {
                if (!mealPlans) continue;
                const mealPlanApplied = mealPlans[filter];
                if (typeof mealPlanApplied === "undefined" || !mealPlanApplied) continue;

                groupTitle.html(mealPlanApplied.cholloMealPlanTitle);
                group.name = mealPlanApplied.cholloMealPlanTitle;
                groupDescription.html(mealPlanApplied.cholloMealPlanDescription);
                groupPrice.html(mealPlanApplied.cholloMealPlanPrice);

                if (mealPlanApplied.labelsInfo) {
                    schematicLabels.html('');
                    $.each(mealPlanApplied.labelsInfo, (index, label) => {
                        const schematicLabel = schematicLabelTemplate.clone(true);
                        const schematicLabelImg = schematicLabel.find('[data-entity="schematic-img"]');
                        const schematicLabelText = schematicLabel.find('[data-entity="schematic-text"]');
                        if (schematicLabelImg) {
                            schematicLabelImg.attr('src', label.img);
                        }
                        if (schematicLabelText) {
                            schematicLabelText.html(label.text);
                        }
                        if (schematicLabel) {
                            schematicLabels.append(schematicLabel);
                        }
                    });
                }

                group.price = {
                    'desc': mealPlanApplied.cholloMealPlanPrice, 'asc': mealPlanApplied.cholloMealPlanPrice
                };
                group.defaultMealPlan = mealPlanApplied.mealPlanId;

                if (additionalMealPlansContainer) {
                    const mealPlanAppliedBadges = $(additionalMealPlansContainer).find('[data-mealplan-id]');
                    $.each(mealPlanAppliedBadges, function (index, element) {
                        element.remove();
                    });

                    const mealPlanToPrint = [];
                    $.each(Object.values(mealPlans), function (index, mealPlan) {
                        if (mealPlan.mealPlanId === mealPlanApplied.mealPlanId) return;
                        mealPlanToPrint.push(mealPlan);
                    });

                    $.each(Object.values(mealPlanToPrint), function (index, mealPlan) {
                        const span = document.createElement('span');
                        span.setAttribute('data-mealplan-id', mealPlan.mealPlanId);
                        span.textContent = mealPlan.mealPlanText;
                        if (index < mealPlanToPrint.length - 1) {
                            span.textContent += ', ';
                        }
                        $(additionalMealPlansContainer).append(span);
                    });
                }
            }
        } else {
            if (!mealPlans) return;
            const mealPlanApplied = Object.values(mealPlans)[0];

            groupTitle.html(mealPlanApplied.cholloMealPlanTitle);
            groupDescription.html(mealPlanApplied.cholloMealPlanDescription);
            groupPrice.html(mealPlanApplied.cholloMealPlanPrice);
            group.price = mealPlanApplied.cholloMealPlanPrice;
            group.name = mealPlanApplied.cholloMealPlanTitle;
            group.defaultMealPlan = mealPlanApplied.mealPlanId;

            if (mealPlanApplied.labelsInfo) {
                schematicLabels.html('');
                $.each(mealPlanApplied.labelsInfo, (index, label) => {
                    const schematicLabel = schematicLabelTemplate.clone(true);
                    const schematicLabelImg = schematicLabel.find('[data-entity="schematic-img"]');
                    const schematicLabelText = schematicLabel.find('[data-entity="schematic-text"]');
                    if (schematicLabelImg) {
                        schematicLabelImg.attr('src', label.img);
                    }
                    if (schematicLabelText) {
                        schematicLabelText.html(label.text);
                    }
                    if (schematicLabel) {
                        schematicLabels.append(schematicLabel);
                    }
                });
            }

            if (additionalMealPlansContainer) {
                const mealPlanAppliedBadges = $(additionalMealPlansContainer).find('[data-mealplan-id]');
                $.each(mealPlanAppliedBadges, function (index, element) {
                    element.remove();
                });

                const mealPlanToPrint = [];
                $.each(Object.values(mealPlans), function (index, mealPlan) {
                    if (mealPlan.mealPlanId === group.defaultMealPlan) return;
                    mealPlanToPrint.push(mealPlan);
                });

                $.each(Object.values(mealPlanToPrint), function (index, mealPlan) {
                    const span = document.createElement('span');
                    span.setAttribute('data-mealplan-id', mealPlan.mealPlanId);
                    span.textContent = mealPlan.mealPlanText;
                    if (index < mealPlanToPrint.length - 1) {
                        span.textContent += ', ';
                    }
                    $(additionalMealPlansContainer).append(span);
                });
            }
        }
    }

    _scrollToElement() {
        let divToScroll = '[data-container="filter-title"]';
        if (!$(divToScroll).is(':visible')) {
            divToScroll = '[data-container="groups"]';
        }

        const divToScrollElement = document.querySelector(divToScroll);
        if (divToScrollElement) {
            const rect = divToScrollElement.getBoundingClientRect();
            const isElementInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            if (!isElementInViewport) {
                myApp.scrollManager.scrollToElement(divToScroll);
            }
        }
    }
};
